import React, {useRef} from 'react'
import {Layout} from '../../../layout'
import {EitjeVirtuoso} from '../../../eitje_virtuoso'
import {TableRow} from '../row'
import './index.less'

export * from './show_more'

export const AdvancedTableBody = ({rows, ...rest}) => {
	const tableBodyRef = useRef()

	return (
		<Layout ref={tableBodyRef} className="advanced-table-body" width="100%" direction="vertical" gap={0}>
			<EitjeVirtuoso
				data={rows}
				customScrollParent=".page-body"
				itemContent={(index, row) => (
					<TableRow
						key={row?.original?.id || index}
						row={row}
						cells={row.getVisibleCells()} // pass row props, to force a rerender in the momoized TableRow when they update
						canExpand={row.getCanExpand()}
						active={row.getIsSelected() || row.getIsAllSubRowsSelected()}
						isGrouped={row.getIsGrouped()}
						{...rest}
					/>
				)}
			/>
		</Layout>
	)
}
